// extracted by mini-css-extract-plugin
export default {"disableClick":"_1GvfF"};